import { jobsAPI } from 'api/jobsAPI'
import { useState } from 'react'

export default function useJob() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [bookingData, setBookingData] = useState<any>(null)

  const reallocateBooking = async (id: any, data: any) => {
    setIsLoading(true)
    setError(false)

    try {
      const resp = await jobsAPI.reallocateBooking(id, data)
      console.log(resp)
      setBookingData(resp)
    } catch (error) {
      setError(true)
    }

    setIsLoading(false)
  }

  return {
    bookingData,
    reallocateBooking,
    isLoading,
    error,
  }
}
